import React, { useState } from "react"
import { Link, useParams } from "react-router"
import { formatDistance } from 'date-fns'
import axios from 'axios'

import useSWR, { mutate } from 'swr'
import fetch from 'isomorphic-unfetch'
const fetcher = url => fetch(url).then(r => r.json())

// viewing a single apps details, uses the :id param
function AppView(){
  const [showForm, setShowForm] = useState(false)
  const [versionNumber, setVersionNumber] = useState('')
  const [changelog, setChangelog] = useState('')
  const [url, setUrl] = useState('')

  const [errorMessage, setErrorMessage] = useState('')

  let { id } = useParams();
  const { data, error } = useSWR('/api/apps/' + id, fetcher)

  const [showJSON, setShowJSON] = useState(false)
  function toggleShowJSON(){
    setShowJSON(!showJSON)
  }

  // TODO: turn these into components
  if (error) return <div className="loading"><p>Failed to load. The server is probably down.</p></div>
  if (!data) return <div className="loading"><p>Loading...</p></div>

  const changeUrl = (e) => {
    setUrl(e.target.value)
  }

  const changeVersionNumber = (e) => {
    setVersionNumber(e.target.value)
  }

  const changeChangelog = (e) => {
    setChangelog(e.target.value)
  }

  function toggleForm(){
    console.log("running toggle form")
    setShowForm(!showForm)
  }

  function dontToggle(event){
    event.stopPropagation();
  }

  const handleUpload = () => {
    if(url === '' || versionNumber === '' || changelog === ''){
      setErrorMessage('Fields not set')
    } else {
      let app = data
      // we'll upload things here
      console.log("url: " + url)
      console.log("versionNumber: " + versionNumber)
      console.log("changelog: " + changelog)
      console.log("UPLOAD")
      setErrorMessage('')

      const formData = new FormData()
      formData.append('url', url)
      formData.append('versionNumber', versionNumber)
      formData.append('changelog', changelog)

      const endpoint = '/api/apps/' + app.bundle + '/' + versionNumber
      axios.post(endpoint, formData, {}).then(res => {
        console.log(res)
        // reset the form/reload the versions list
        setUrl('')
        setVersionNumber('')
        setChangelog('')
        setErrorMessage('')
        setShowForm(false)

        // tell swr to refresh any data using this endpoint
        mutate('/api/apps/' + id)

      }).catch(err => {
        console.log(err)
      })

    }
  }


  const deleteVersion = (version_id) => {
    console.log('version_id: ' + version_id)

    const fd = new FormData()
    fd.append('version_id', version_id)

    const endpoint = '/api/apps/version/delete/'
    axios.post(endpoint, fd, {}).then(res => {
      console.log(res)
      // tell swr to refresh any data using this endpoint
      mutate('/api/apps/' + id)
    }).catch(err => {
      console.log(err)
    })
  }


  return(
    <div>
      <h1>{data.displayName}</h1>
      <p className="subtitle">{data.bundle}</p>
      <Link to={"/"}>Back</Link>
      <h2>Versions <button className="inline-control-small inline-right" onClick={toggleForm}><span>+</span></button></h2>

      <div className="form" style={{ display: (showForm ? "block" : "none")}}  onClick={toggleForm}>
        <div className="form-modal" onClick={dontToggle} >

          <h3>New App Version</h3>
          <p>Upload an apk to the cdn and enter the details here</p>
          <p className='error-message'><b><i>{errorMessage}</i></b></p>
          <p><input type="text" value={url} placeholder="https://url/somefilename" name="url" onChange={changeUrl}></input></p>
          <p><input type="text" value={versionNumber} placeholder="0.0.0" name="version" onChange={changeVersionNumber}></input></p>
          <p><textarea type="text" value={changelog} placeholder="Changelog" name="changelog" onChange={changeChangelog}></textarea></p>
          <p><input type='submit' value='Create' onClick={handleUpload} /></p>
        </div>
      </div>

      <div>
        {data.versions.map(version => (
          <div className='version-details'>
            <h3>Version {version.versionNumber} <span className="subtitle">- {formatDistance(new Date(version.createdAt), new Date(), {addSuffix: true})}</span></h3>
            <p>
              <button className="deleteBtn" onClick={() => deleteVersion(version.id)}>Delete Version</button> (Version is set on [{version.Groups.length}] Groups)
            </p>
            <p><b>APK Name:</b> {version.apk}</p>
            <p><b>URL:</b> {version.url}</p>
            <p><b>Changelog</b></p>
            <pre>{version.changelog}</pre>
          </div>
        ))}
      </div>

      <div>
        <h1>JSON OUTPUT <button className="inline-control-small" onClick={toggleShowJSON}><span>{showJSON ? "hide" : "show"}</span></button></h1>
        <pre className={showJSON ? "" : "hidden"}>{JSON.stringify(data, null, 3)}</pre>
      </div>
    </div>
  )
}

export default AppView;
